// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FlVOM8DBPqW6L0 {\n  font-size: 12px;\n  text-decoration: underline;\n  cursor: pointer;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ctaButton": "FlVOM8DBPqW6L0"
};
export default ___CSS_LOADER_EXPORT___;
